<template>
    <div class="combined-container">
        <div class="design-section">
            <div class="content-wrapper">
                <div class="update-box">
                    <p class="update-text">{{ updateText }}</p>
                </div>

                <p class="subtitle">
                    <strong>〜業界最安値級・最短当日対応可能〜</strong>
                </p>

                <h2 class="title">
                    <span class="orange-outline">3つの条件をクリアした</span><br />
                    <span class="blue">給湯器おすすめ業者</span>
                    <span class="orange-outline2">3選</span>
                </h2>
                <div class="divider"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RankingBanner',
    data() {
        return {
            updateText: '',
        };
    },
    created() {
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        this.updateText = `${year}年${month}月更新`;
    },
};
</script>

<style scoped>
.design-section {
    position: relative;
    padding: 20px 20px;
    background-color: #eef5ff;
    text-align: center;
}

.content-wrapper {
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* 更新日 */
.update-box {
    background-color: #0e3d7a;
    color: white;
    padding: 6px 16px;
    border-radius: 4px;
}

.update-text {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
}

/* サブタイトル */
.subtitle {
    font-size: 24px;
    font-weight: 900;
    color: #0e3d7a;
    margin: 8px 0;
}

.subtitle span {
    color: #0e3d7a;
    font-size: 20px;
    margin-left: 4px;
}

/* タイトル */
.title {
    font-size: 32px;
    font-weight: 900;
    color: #0e3d7a;
    margin: 10px 0;
    line-height: 1.3;
}

.title .blue {
    color: #0e3d7a;
    font-size: 34px;
}

.top-5 {
    font-size: 38px;
    margin-left: 8px;
}

/* オレンジ文字 */
.orange-outline {
    color: #ff8c00;
}

/* 区切り線 */
.divider {
    width: 80%;
    max-width: 500px;
    height: 1px;
    border-bottom: 3px dashed #bbb;
}

/* スマホ対応 */
@media (max-width: 480px) {
    .content-wrapper {
        padding-top: 20px;
        margin-bottom: 20px;
    }

    .design-section {
        padding: 5px;
    }

    .update-text {
        font-size: 1rem;
    }

    .subtitle {
        font-size: 1.25rem;
    }

    .subtitle span {
        font-size: 0.9rem;
    }

    .title {
        font-size: 2.1rem;
        margin-top: 0;
    }

    .orange-outline {
        font-size: 1.6rem;
    }

    .orange-outline2 {
        color: #ff8c00;
        font-size: 2rem;
    }

    .title .blue {
        font-size: 1.8rem;
    }

    .top-5 {
        font-size: 2.2rem;
    }
}
</style>
